import { createAction } from "redux-actions";

export const ADD_ROOM = "ADD_ROOM";
export const addRoom = createAction(ADD_ROOM);

export const ADD_ROOM_FAILURE = "ADD_ROOM_FAILURE";
export const addRoomFailure = createAction(ADD_ROOM_FAILURE);

export const ADD_ROOM_REQUESTED = "ADD_ROOM_REQUESTED";
export const addRoomRequested = createAction(ADD_ROOM_REQUESTED);

export const ADD_ROOM_SUCCESS = "ADD_ROOM_SUCCESS";
export const addRoomSuccess = createAction(ADD_ROOM_SUCCESS);

export const FETCH_ROOM = "FETCH_ROOM";
export const fetchRoom = createAction(FETCH_ROOM);

export const FETCH_ROOM_REQUESTED = "FETCH_ROOM_REQUESTED";
export const fetchRoomRequested = createAction(FETCH_ROOM_REQUESTED);

export const FETCH_ROOM_FAILURE = "FETCH_ROOM_FAILURE";
export const fetchRoomFailure = createAction(FETCH_ROOM_FAILURE);

export const FETCH_ROOM_SUCCESS = "FETCH_ROOM_SUCCESS";
export const fetchRoomSuccess = createAction(FETCH_ROOM_SUCCESS);

export const FETCH_ROOM_BY_ID = "FETCH_ROOM_BY_ID";
export const fetchRoomById = createAction(FETCH_ROOM_BY_ID);

export const FETCH_ROOM_BY_ID_FAILURE = "FETCH_ROOM_BY_ID_FAILURE";
export const fetchRoomByIdFailure = createAction(FETCH_ROOM_BY_ID_FAILURE);

export const FETCH_ROOM_BY_ID_REQUESTED = "FETCH_ROOM_BY_ID_REQUESTED";
export const fetchRoomByIdRequested = createAction(FETCH_ROOM_BY_ID_REQUESTED);

export const FETCH_ROOM_BY_ID_SUCCESS = "FETCH_ROOM_BY_ID_SUCCESS";
export const fetchRoomByIdSuccess = createAction(FETCH_ROOM_BY_ID_SUCCESS);
